import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const InviteContainerStyle = (theme: Theme) =>
  createStyles({
    page: {
      minHeight: '100vh',
      position: 'relative',
      paddingTop: theme.spacing(8),
    },
    languageSelect: {
      position: 'absolute',
      top: theme.spacing(6.5),
      right: theme.spacing(6.5),
      zIndex: 3,
    },
    contentBox : {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: styleColors.lightBeige,
      gap: '20px',
      margin: '20px',
      borderRadius: '20px',
      textAlign: 'center',
      marginTop:'50px',
    },
  });



// WEBPACK FOOTER //
// ./src/containers/invite/invite.style.ts